import { createSlice } from "@reduxjs/toolkit";

import FileModel from "models/FileModel";
import { getPdf } from "services/pdf.service";

import { RootState } from "store/store";

interface CreditMemoState {
    loading: boolean;
    loadingIds: (number | string)[];
    pdfs: FileModel[];
    selectedPdfs?: FileModel[] | null;
}

const initialState: CreditMemoState = {
    pdfs: [],
    loadingIds: [],
    loading: false
}

export const pdfsSlice = createSlice({
    name: "pdfs",
    initialState,
    reducers: {
        clearPdf: (state) => {
            state.selectedPdfs = null;
        },
        setPdf: (state, action) => {
            state.selectedPdfs = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPdf.pending, (state, action) => {
                state.loadingIds.push(action.meta.arg.fileId);
            })
            .addCase(getPdf.fulfilled, (state, action) => {
                if (action.payload &&
                    action.payload.length > 0) {
                    for (let i = 0; i < action.payload.length; i++) {
                        const selectedIndex = state.pdfs.map(e => e.fileId).indexOf(action.payload[i].fileId);
                        if (selectedIndex < 0) {
                            state.pdfs.push(action.payload[i]);
                        } else {
                            state.pdfs[selectedIndex] = action.payload[i];
                        }
                    }
                }

                const fileId = action.meta.arg.fileId;
                const index = state.loadingIds.indexOf(fileId);
                if (index > -1) {
                    state.loadingIds.splice(index, 1);
                }
            })
            .addCase(getPdf.rejected, (state, action) => {
                const fileId = action.meta.arg.fileId;
                const index = state.loadingIds.indexOf(fileId, 0);
                const pdfIndex = state.pdfs.map(e => e.fileId).indexOf(fileId);
                if (index > -1) {
                    state.loadingIds.splice(index, 1);
                }
                if (pdfIndex > -1) {
                    state.pdfs[pdfIndex].file = "";
                }
                else
                    state.pdfs.push({fileId: fileId, file: "", name: ""});
            })
    }
});

export const getPdfByName = (
    files: FileModel[],
    name: string
) => {
    return files.filter(c => c.name.indexOf(name) > -1 || c.fileId.indexOf(name) > -1);
};

export const selectPdfsDto = (state: RootState) => state.pdfs.pdfs;
export const pdfsReducer = pdfsSlice.reducer;
export const { clearPdf, setPdf } = pdfsSlice.actions;